import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isEmptyOrBlankString } from '@philips-internal/oswald-ui-utils';
const NOT_CONTAINS = 'not-contains';
function NotContainsValidator(value, { prefix = '', suffix = '', text = '' } = {}) {
    const validPrefix = isEmptyOrBlankString(prefix) || !String(value).startsWith(prefix);
    const validSuffix = isEmptyOrBlankString(suffix) || !String(value).endsWith(suffix);
    const validText = isEmptyOrBlankString(text) || !String(value).includes(text);
    return [
        {
            message: MessageService.translate('tws.validator.not-start-with', { prefix }),
            name: NOT_CONTAINS,
            valid: validPrefix,
        },
        {
            message: MessageService.translate('tws.validator.not-end-with', { suffix }),
            name: NOT_CONTAINS,
            valid: validSuffix,
        },
        {
            message: MessageService.translate('tws.validator.not-contains', { text }),
            name: NOT_CONTAINS,
            valid: validText,
        },
    ];
}
NotContainsValidator.optionTypes = {
    prefix: string,
    suffix: string,
    text: string,
};
export { NOT_CONTAINS, NotContainsValidator, };
export default NotContainsValidator;
//# sourceMappingURL=not-contains.js.map